// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-OAuth2-module__panel-eE7Eg {
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: 0px;
  max-width: 400px;
}

.nightbot-OAuth2-module__header-cMweu {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
}

.nightbot-OAuth2-module__title-NK6WQ {
  color: var(--text-secondary);
}

.nightbot-OAuth2-module__userWarningContainer-pMb7s {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
}

.nightbot-OAuth2-module__userWarning-LZX6T {
  display: flex;
  gap: 8px;
  align-self: center;
}

.nightbot-OAuth2-module__userWarningText-dAwnT {
  display: flex;
  flex-direction: column;
}

.nightbot-OAuth2-module__scopeListItem-g_OCj {
  font-size: var(--mantine-font-size-sm);
  color: var(--text-secondary);
}

.nightbot-OAuth2-module__warningText-BFoT6 {
  color: var(--text-secondary);
}

.nightbot-OAuth2-module__applicationInfo-xFmTg {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
}

.nightbot-OAuth2-module__applicationActions-AxRTa {
  display: flex;
  align-self: center;
  gap: 24px;
  padding: 24px;
  width: 100%;
}

.nightbot-OAuth2-module__authorizeApplicationText-ypuIK {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/OAuth2.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".panel {\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n  gap: 0px;\n  max-width: 400px;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 24px;\n}\n\n.title {\n  color: var(--text-secondary);\n}\n\n.userWarningContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  gap: 16px;\n}\n\n.userWarning {\n  display: flex;\n  gap: 8px;\n  align-self: center;\n}\n\n.userWarningText {\n  display: flex;\n  flex-direction: column;\n}\n\n.scopeListItem {\n  font-size: var(--mantine-font-size-sm);\n  color: var(--text-secondary);\n}\n\n.warningText {\n  color: var(--text-secondary);\n}\n\n.applicationInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 24px;\n}\n\n.applicationActions {\n  display: flex;\n  align-self: center;\n  gap: 24px;\n  padding: 24px;\n  width: 100%;\n}\n\n.authorizeApplicationText {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `nightbot-OAuth2-module__panel-eE7Eg`,
	"header": `nightbot-OAuth2-module__header-cMweu`,
	"title": `nightbot-OAuth2-module__title-NK6WQ`,
	"userWarningContainer": `nightbot-OAuth2-module__userWarningContainer-pMb7s`,
	"userWarning": `nightbot-OAuth2-module__userWarning-LZX6T`,
	"userWarningText": `nightbot-OAuth2-module__userWarningText-dAwnT`,
	"scopeListItem": `nightbot-OAuth2-module__scopeListItem-g_OCj`,
	"warningText": `nightbot-OAuth2-module__warningText-BFoT6`,
	"applicationInfo": `nightbot-OAuth2-module__applicationInfo-xFmTg`,
	"applicationActions": `nightbot-OAuth2-module__applicationActions-AxRTa`,
	"authorizeApplicationText": `nightbot-OAuth2-module__authorizeApplicationText-ypuIK`
};
export default ___CSS_LOADER_EXPORT___;
